import React from 'react';
import PropTypes from 'prop-types';

import { LoadingStyled, SpinnerStyled, TextStyled } from './Loading.styled';

/**
 * **Loading** is used to indicate to users that a page request or an upload is being processed.
 */
function Loading({ className, text, isLayoutCentered }) {
  return (
    <LoadingStyled
      className={className}
      isLayoutCentered={isLayoutCentered}
      role='alert'
      aria-live='assertive'
    >
      <SpinnerStyled />
      {text && <TextStyled>{text}</TextStyled>}
    </LoadingStyled>
  );
}

export default Loading;

Loading.defaultProps = {
  isLayoutCentered: true,
};

Loading.propTypes = {
  className: PropTypes.string,
  /**
   * Text to show below Spinner
   */
  text: PropTypes.string,
  /**
   * Centering Loading on its container
   */
  isLayoutCentered: PropTypes.bool,
};
